<template>
  
  <v-dialog v-model="dialog" :width="width" max-width="100%" scrollable persistent content-class="global-modal-content"
    :z-index="9999">

    <v-card>
      <!-- Tombol Close di kanan atas -->
      <v-btn icon small @click="close" style="position: absolute; top: 8px; right: 8px; z-index: 10;">
        <v-icon style="color: red">mdi-close</v-icon>
      </v-btn>

      <!-- Judul dengan border bawah -->
      <v-card-title class="pa-4 d-flex align-center" style="border-bottom: 1px solid #e0e0e0;">
        <span class="text-h6 font-weight-medium">{{ title }}</span>
      </v-card-title>

      <!-- Konten -->
      <v-card-text class="mt-4">
        <slot />
      </v-card-text>
      <v-card-actions>
        <slot name="actions" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: Boolean,
    title: String,
    width: {
      type: [String, Number],
      default: 600 // fallback jika tidak dikirim
    },

  },
  watch: {
    dialog(val) {
      if (val) {
        this.$emit('open')
      }
    }
  },
  computed: {
    dialog: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
        if (!val) this.$emit('close')
      }
    }
  },
  methods: {
    close() {
      this.dialog = false
    }
  },


}
</script>
